module.exports = __webpack_public_path__ + "media/src/assets/images/about-pic3-5a082b4db0af0c56de2153b872d4ae19.png";